import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context";
import { FetchCurrentWatchingCourse } from "../../utility";
import Animator from "../Aminator/Animator";
import { useIsMobile } from "../hooks/useIsMobile";
import {
  LiveCourseIcon,
  OnlineCourseIcon,
  SheduleCourseIcon,
  WatchCourseIcon,
} from "./IconButton";

export default function DashboardHeader({
  onClick = (e) => {},
  schedule,
  onClick1 = (e) => {},
}) {
  const { userCoursesState, authState } = useContext(GlobalContext);
  const mobile = useIsMobile();

  const [data, setData] = useState({});
  const currentWatchingStatus = async () => {
    const res = await FetchCurrentWatchingCourse(
      authState?.data?.id?.toString()
    );
    // console.log("prbjks", res.status);
    if (res.status) {
      setData(res.data);
    }
  };
  useEffect(() => {
    currentWatchingStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const courses = Array.isArray(userCoursesState?.data) ? userCoursesState.data : [];
  const sectionMyOneCourses = courses.filter((course) => course?.course_type === "online");
  const sectionMyTwoCourses = courses.filter((course) => course?.course_type === "live");

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        marginTop: mobile ? 30 : 60,
        gap: 16,
      }}
    >
      <Animator delay={400} timeout={400} variant={mobile ? "zoom" : "zoom"}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClick("live");
          }}
          style={{
            width: mobile ? "48%" : "23%",
            display: "block",
          }}
        >
          <div
            className="border border-orange-100 bg-orange-50/60 hover:bg-orange-100/60 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md"
            style={{
              cursor: "pointer",
              padding: "20px",
              borderRadius: 16,
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <LiveCourseIcon />
            <div>
              <h1
                style={{
                  color: "#7c2d12",
                  fontSize: 20,
                  fontWeight: 700,
                  marginBottom: 2,
                }}
              >
                {sectionMyTwoCourses?.length || 0}{" "}
                {sectionMyTwoCourses?.length === 1 ? "Course" : "Courses"}
              </h1>
              <p
                style={{
                  color: "#ea580c",
                  fontSize: 13,
                  fontWeight: 500,
                }}
              >
                Live Sessions
              </p>
            </div>
          </div>
        </a>
      </Animator>
      <Animator delay={450} timeout={450} variant="zoom">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClick("online");
          }}
          style={{
            width: mobile ? "48%" : "23%",
            display: "block",
          }}
        >
          <div
            className="border border-blue-100 bg-blue-50/60 hover:bg-blue-100/60 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md"
            style={{
              cursor: "pointer",
              padding: "20px",
              borderRadius: 16,
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <OnlineCourseIcon />
            <div>
              <h1
                style={{
                  color: "#1e3a8a",
                  fontSize: 20,
                  fontWeight: 700,
                  marginBottom: 2,
                }}
              >
                {sectionMyOneCourses?.length || 0}{" "}
                {sectionMyOneCourses?.length === 1 ? "Course" : "Courses"}
              </h1>
              <p
                style={{
                  color: "#2563eb",
                  fontSize: 13,
                  fontWeight: 500,
                }}
              >
                Online Courses
              </p>
            </div>
          </div>
        </a>
      </Animator>
      <Animator delay={500} timeout={500} variant="zoom">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClick("watch");
          }}
          style={{
            width: mobile ? "48%" : "23%",
            display: "block",
          }}
        >
          <div
            className="border border-pink-100 bg-pink-50/60 hover:bg-pink-100/60 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md"
            style={{
              cursor: "pointer",
              padding: "20px",
              borderRadius: 16,
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <WatchCourseIcon />
            <div>
              <h1
                style={{
                  color: "#831843",
                  fontSize: 20,
                  fontWeight: 700,
                  marginBottom: 2,
                }}
              >
                {data?.title ? 1 : 0} Course
              </h1>
              <p
                style={{
                  color: "#db2777",
                  fontSize: 13,
                  fontWeight: 500,
                }}
              >
                Watched Video
              </p>
            </div>
          </div>
        </a>
      </Animator>
      <Animator
        delay={600}
        timeout={600}
        direction="left"
        variant={mobile ? "zoom" : "zoom"}
      >
        <div
          className="border border-emerald-100 bg-emerald-50/60 hover:bg-emerald-100/60 transition-all duration-300 shadow-sm hover:shadow-md"
          style={{
            padding: "20px",
            width: mobile ? "48%" : "100%",
            borderRadius: 16,
            flexWrap: "wrap",
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          <SheduleCourseIcon />
          <div>
            <h1
              style={{
                color: "#064e3b",
                fontSize: 20,
                fontWeight: 700,
                marginBottom: 2,
              }}
            >
              {schedule?.length || 0}{" "}
              {schedule?.length === 1 ? "Course" : "Courses"}
            </h1>
            <p
              style={{
                color: "#059669",
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              Schedules
            </p>
          </div>
        </div>
      </Animator>
    </div>
  );
}
